import React from 'react';

function Header() {
    return (
        <header>
        <img src={"./trollface.png"} alt="trollface" />
        <h1>Meme Generator</h1>
        </header>
    )
}

export default Header;